import * as React from 'react';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';

import CachedIcon from '@mui/icons-material/Cached';

class ReloadButton extends React.Component {
  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;
    this.state = {
      loadingProgress: 0,
    };
  }

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  componentDidMount() {
    this.interval = setInterval(() => {
      if (this.state.loadingProgress !== 100) {
        this.setState({ loadingProgress: this.state.loadingProgress + 2.5 });
      } else {
        this.props.reloadPage();
        this.setState({ loadingProgress: 0 });
      }
    }, 250);
  }

  render() {
    return (
      <Box
        sx={{
          position: 'absolute',
          top: 31,
          right: 50,
        }}>
        <Button
          variant="contained"
          startIcon={<CachedIcon />}
          onClick={() => {
            this.props.reloadPage();
            this.setState({ loadingProgress: 0 });
          }}>
          Reload
        </Button>
        <LinearProgress
          sx={{
            position: 'relative',
            width: '96%',
            paddingLeft: 0.4,
          }}
          variant="determinate"
          color="secondary"
          value={this.state.loadingProgress}
        />
      </Box>
    );
  }
}

export default withCookies(ReloadButton);
